import React, { useEffect, useState, useContext } from "react";
import axios from "axios";
import { TranslatorContext } from "../../context/Translator";
import "../../components/tables/DashboardCountList.css";
import { NumericFormat } from 'react-number-format';

import { Table, Container, Row, Col } from "react-bootstrap";
import PageLayout from "../../layouts/PageLayout";
import { Link, useNavigate, useLocation } from "react-router-dom";
import PulseLoader from "react-spinners/PulseLoader";
import { AnchorComponent } from "../../components/elements";

function DashboardCountList({ data, formState }) {
    const [selfKey, setSelfKey] = useState(null)
    const [count, setCount] = useState(false)
    const [school, setSchool] = useState(false)
    const [title, setTitle] = useState(false)
    const [intitle, setinTitle] = useState(false)
    const handleCardClick = (key, title) => {
        setSelfKey(key);
        setinTitle(title);
    };

    useEffect(() => {
        if (selfKey) {
            fetchData();
        }
    }, [selfKey]);
    const { state } = useLocation();
    const navigate = useNavigate();
    const { t } = useContext(TranslatorContext);
    const [counts, setCounts] = useState([{
        teenage_count: 0,
        totalAdultRescued: 0,
        youthCount: 0
    }]);
    const [details, setDetails] = useState([]);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState("");

    const [pagination, setPagination] = useState({
        current_page: 1,
        last_page: 1,
        next_page_url: null,
        prev_page_url: null,
        total: 0,
        required_page: 1,
    });

    // ✅ Fetch Data (with pagination + filters)
    const fetchData = async (page = 1) => {
        const AuthToken = localStorage.getItem("AuthUser");
        setLoading(true);
        try {
            axios.defaults.headers.common["Authorization"] = `Bearer ${AuthToken}`;
            const params = { page };
            setTitle(state?.title)
            // Filters from state (if passed via navigation)
            if (state?.key && !selfKey) {
                params.key = state.key;
            } else if (selfKey) {
                params.key = selfKey;
            }
            if (state?.category) params.category = state.category;
            if (state?.ppi) params.req_id = state.ppi;
            if (state?.group) params.org = state.group;
            if (state?.donor) params.donor = state.donor;
            if (state?.from_date) params.from_date = state.from_date;
            if (state?.to_date) params.to_date = state.to_date;

            const res = await axios.get(
                `${process.env.REACT_APP_API_URL}/dashboard`,
                { params }
            );

            if (res.data.success) {
                const data = res.data?.peoples;

                setDetails(data.data || []);
                setPagination({
                    current_page: data?.current_page,
                    last_page: data?.last_page,
                    next_page_url: data?.next_page_url,
                    prev_page_url: data?.prev_page_url,
                    total: data?.total,
                    required_page: data?.current_page,
                });

                console.log(res.data.teenage_count)
                setCounts(prev => ({
                    ...prev,
                    teenage_count: res.data.teenage_count,
                    youthCount: res.data.youthCount,
                    totalAdultRescued: res.data.totalAdultRescued
                }));
                setCount(res.data.count)
                setSchool(res.data.school)
                if (intitle)
                    setTitle(intitle);
            }
        } catch (error) {
            console.error(error);
        } finally {
            setLoading(false);
        }
    };

    // ✅ Handle page change by number button
    const handlePageChange = (page) => {
        if (page >= 1 && page <= pagination.last_page) {
            // ✅ Preserve existing query params (filters, search, etc.)
            const params = new URLSearchParams(location.search);
            params.set("page", page);

            // ✅ Keep state (like key, filters, etc.) while navigating
            navigate(`?${params.toString()}`, {
                state: {
                    ...location.state,   // retain existing state values
                    page                // update page value
                },
            });

            // ✅ Fetch new data
            fetchData(page);
        }
    };


    // ✅ Page input change
    const handleRequiredPageChange = (e) => {
        setPagination((prev) => ({ ...prev, required_page: e.target.value }));
    };

    // ✅ Page input submit
    const handlePageInputSubmit = () => {
        const page = Number(pagination.required_page);
        if (page >= 1 && page <= pagination.last_page) {
            handlePageChange(page);
            setError("");
        } else {
            setError(`Enter page 1 to ${pagination.last_page}`);
        }
    };

    // ✅ Load on mount & when ?page changes
    const location = useLocation();
    useEffect(() => {
        const params = new URLSearchParams(location.search);
        const page = Number(params.get("page")) || 1;
        fetchData(page);
    }, [location.search, state]);
    const floats = [

        {
            key: "teenage_count",

            title: "Teenage Children (13-19 age)",
            digit: Number(counts?.teenage_count),
            icon: "price_check",
            variant: "lg blue",
        },
        {
            key: "youth_count",

            title: "Youth Rescued (19-25 age)",
            digit: counts?.youthCount,
            icon: "price_check",
            variant: "lg blue",
        },
        {
            key: "total_adult_rescued",
            title: "Young Adult Rescued (25 & above age)",
            digit: counts?.totalAdultRescued,
            icon: "settings_accessibility",
            variant: "lg green",
        },
    ]
    return (
        <PageLayout>
            <Container className="mt-4">
                {loading ? (
                    <div className="d-flex justify-content-center align-items-center" style={{ height: "40vh", gap: "8px" }}>
                        <h3 style={{ color: "#077834", fontWeight: "bold", marginBottom: "0" }}>Loading...</h3>
                        <PulseLoader color="#077834" loading={loading} size={6} />
                    </div>
                ) : (

                    <Row>

                        <Col xl={12}>
                            <div className="mc-card">
                                <div className='mc-breadcrumb'>
                                    <h3 className="mc-breadcrumb-title">
                                        {decodeURIComponent(title)}
                                    </h3>
                                    <ul className="mc-breadcrumb-list">
                                        <li className="mc-breadcrumb-item"><Link to='/' state={{ restoreDashboard: true }} className="mc-breadcrumb-link">{t('home')}</Link></li>
                                        <li className="mc-breadcrumb-item"><Link to='#' className="mc-breadcrumb-link">{t('Lisitng')}</Link></li>
                                        <li className="mc-breadcrumb-item"> {decodeURIComponent(title)}</li>
                                    </ul>
                                </div>
                            </div>
                        </Col>
                        {count ? floats.map((data, index) => {


                            return (


                                <Col
                                    key={index}
                                    sm={6}
                                    lg={4}
                                >
                                    <div

                                        onClick={data.noclick ? null : () => handleCardClick(data.key, data.title)
                                        }
                                        className={`mc-float-card ${data.variant}`
                                        }
                                        style={{
                                            background:
                                                "linear-gradient(to right, rgba(0,0,0,0.8), #077834)",
                                            cursor: data.noclick ? "default" : "pointer",
                                        }}
                                    >
                                        <h3>	<NumericFormat
                                            value={data.digit}
                                            displayType="text"
                                            thousandSeparator
                                            className="card-number"
                                        />
                                        </h3>
                                        <p>{data.title}</p>
                                        <i
                                            className="material-icons"
                                            style={{ color: "#077834" }}
                                        >
                                            {data.icon}
                                        </i>
                                    </div >
                                </Col >

                            );
                        }) : ""}
                        <Col lg="12">
                            <div className="table-scrollable">
                                <Table striped bordered hover className="mc-table product">
                                    <thead className="mc-table-head">
                                        <tr>

                                            <th>FSF ID</th>
                                            <th>Person Name</th>
                                            {
                                                details.some(item => 'patient_name' in item) ?
                                                    <th>Patient Name</th> : null
                                            }
                                            {
                                                details.some(item => 'date_of_church_engagement' in item) ?
                                                    <th>Date of Church Engagement</th> : null
                                            }
                                            {
                                                details.some(item => 'place_name' in item) ?
                                                    <th>Place Name</th> : null
                                            }
                                            {
                                                details.some(item => 'child_name' in item) ?
                                                    <th>Children Name</th> : null
                                            }
                                            {
                                                details.some(item => 'male_name' in item) ?
                                                    <th>Male Name</th> : null
                                            }

                                            {
                                                details.some(item => 'female_name' in item) ?
                                                    <th>Female Name</th> : null
                                            }
                                            {
                                                details.some(item => 'student_name' in item) ?
                                                    <th>Student Name</th> : null
                                            }
                                            {
                                                details.some(item => 'relation' in item) ?
                                                    <th>Relation</th> : null
                                            }
                                            {
                                                details.some(item => 'institute_name' in item) ?
                                                    <th>Institute</th> : null
                                            }
                                            {
                                                school ? <>
                                                    <th>School</th>
                                                    <th>Session</th>
                                                    <th>Class</th></> : null
                                            }
                                            {
                                                details.some(item => 'course_name' in item) ?
                                                    <th>Course</th> : null
                                            }
                                            {
                                                details.some(item => 'amount' in item) ?
                                                    <th>Amount</th> : null
                                            }
                                            {
                                                details.some(item => 'faith_name' in item) ?
                                                    <th>Faith Name</th> : null
                                            }
                                            {details.some(item => 'business_type' in item) ?
                                                <th>Business Type</th> : null
                                            }
                                            {details.some(item => 'loan_type' in item) ?
                                                <th>Loan Type</th> : null
                                            }
                                            {
                                                details.some(item => 'follow_ups_count' in item) ?
                                                    <th>Follow Ups Count</th> : null
                                            }
                                            <th>Actions</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {details.length > 0 ? (
                                            details.map((detail, index) => (
                                                <tr key={detail.id}>

                                                    <td>{detail.f_number}</td>
                                                    <td>{detail.beneficiary_name}</td>
                                                    {
                                                        details.some(item => 'patient_name' in item) ?
                                                            <td>{detail.patient_name}</td> : null
                                                    }
                                                    {
                                                        details.some(item => 'date_of_church_engagement' in item) ?
                                                            <td>{detail.date_of_church_engagement}</td> : null
                                                    }
                                                    {
                                                        details.some(item => 'place_name' in item) ?
                                                            <td>{detail.place_name}</td> : null
                                                    }

                                                    {
                                                        details.some(item => 'child_name' in item) ?
                                                            <td>{detail.child_name}</td> : null}
                                                    {
                                                        details.some(item => 'male_name' in item) ?
                                                            <td>{detail.male_name}</td> : null
                                                    }

                                                    {
                                                        details.some(item => 'female_name' in item) ?
                                                            <td>{detail.female_name}</td> : null
                                                    }
                                                    {
                                                        details.some(item => 'student_name' in item) ?
                                                            <td>{detail.student_name}</td> : null
                                                    }
                                                    {
                                                        details.some(item => 'relation' in item) ?
                                                            <td>{detail.relation}</td> : null
                                                    }
                                                    {
                                                        details.some(item => 'institute_name' in item) ?
                                                            <td>{detail.institute_name}</td> : null
                                                    }
                                                    {
                                                        school ? <>
                                                            <td>{detail.school_name}</td>
                                                            <td>{detail.session}</td>
                                                            <td>{detail.class}</td>
                                                        </> : null
                                                    }

                                                    {
                                                        details.some(item => 'course_name' in item) ?
                                                            <td>{detail.course_name}</td> : null
                                                    }
                                                    {
                                                        details.some(item => 'amount' in item) ?
                                                            <td>{detail.amount}</td> : null
                                                    }

                                                    {
                                                        details.some(item => 'faith_name' in item) ?
                                                            <td>{detail.faith_name}</td> : null
                                                    }
                                                    {
                                                        details.some(item => 'business_type' in item) ?
                                                            <td>{detail.business_type}</td> : null
                                                    }
                                                    {
                                                        details.some(item => 'loan_type' in item) ?
                                                            <td>{detail.loan_type}</td> : null
                                                    }
                                                    {
                                                        details.some(item => 'follow_ups_count' in item) ?
                                                            <td>{detail.follow_ups_count}</td> : null
                                                    }
                                                    <td>
                                                        <AnchorComponent
                                                            className="material-icons view"
                                                            to={
                                                                details.some(item => "institute_name" in item)
                                                                    ? `/vocational-training/${detail.id}`
                                                                    : details.some(item => "school_name" in item)
                                                                        ? `/view-school-enrollment/${detail.enrollment_id}`
                                                                        : `/family-report/${detail.f_number}`
                                                            }

                                                        >
                                                            visibility
                                                        </AnchorComponent>
                                                    </td>
                                                </tr>
                                            ))
                                        ) : (
                                            <tr>
                                                <td colSpan="4" style={{ textAlign: "center" }}>No Records Found</td>
                                            </tr>
                                        )}
                                    </tbody>
                                </Table>
                            </div>
                        </Col>
                    </Row>
                )}

                {/* ✅ Pagination */}
                {!loading && (
                    <div className="mc-paginate">
                        <p className="mc-paginate-title">
                            {t("showing")} <b>{details.length}</b> {t("of")} <b>{pagination.total}</b> {t("results")}
                        </p>

                        <ul className="mc-paginate-list">
                            <li onClick={() => handlePageChange(pagination.current_page - 1)}>
                                <i className="material-icons">chevron_left</i>
                            </li>

                            {[...Array(pagination.last_page)].slice(0, 10).map((_, idx) => {
                                const page = idx + 1;
                                return (
                                    <li
                                        key={page}
                                        onClick={() => handlePageChange(page)}
                                        style={{
                                            backgroundColor: page === pagination.current_page ? "#077834" : "#e8f5e9",
                                            color: page === pagination.current_page ? "#fff" : "#077834",
                                        }}
                                    >
                                        {page}
                                    </li>
                                );
                            })}

                            <li onClick={() => handlePageChange(pagination.current_page + 1)}>
                                <i className="material-icons">chevron_right</i>
                            </li>
                        </ul>

                        <div className="d-flex mt-2">
                            <input
                                type="number"
                                value={pagination.required_page}
                                onChange={handleRequiredPageChange}
                                style={{ width: "70px", marginRight: "10px" }}
                            />
                            <button onClick={handlePageInputSubmit} className="btn btn-success btn-sm">
                                Go
                            </button>
                        </div>

                        {error && <p style={{ color: "red" }}>{error}</p>}
                    </div>
                )}
            </Container>
        </PageLayout >
    );
}

export default DashboardCountList;
